import { render } from "./NotFound.vue?vue&type=template&id=2d108754&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=2d108754&scoped=true&lang=css"

import exportComponent from "/Users/Shared/Previously Relocated Items/Security/data/www/solo/CyReport/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d108754"]])

export default __exports__